import Cookies from "js-cookie";

// export const apiUrl = "https://foodoorapipro.codedady.com/";
export const apiUrl = "https://live-api.foodoor.in/";
export const AccessToken = Cookies.get("DBtoken");
